// extracted by css-extract-rspack-plugin
export default {"FormControl":"get-project-items-block-module__FormControl__eF0M2","Box":"get-project-items-block-module__Box__wswtk"};